export default __webpack_public_path__ + "static/media/big-cross.0e613b8d.svg";